import React from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { Button } from 'rmwc/Button';
import { getEvent, getImageSrc, checkAttend, requestABuddy } from "../api/FirebaseAPI";
import { FormatDate_ddd_MMM_d_yyyy, FormatTimeRange_h_mm } from "../lib/DateTimeFormatFunctions";
import "./EventPage.css"
import {Helmet} from "react-helmet";
import ReactGA from 'react-ga'
import { signIn } from '../api/EmailLinkAuthentication'

export default class EventPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      event:undefined,
      imgSrc:"",
      buddyRequested: false
    }
    this.renderButtons = this.renderButtons.bind(this);
    this.handleClickRequestABuddy = this.handleClickRequestABuddy.bind(this);
  }

  async componentWillMount() {
    let id = this.props.match.params.id;
    this.setState({event: await getEvent(id)});
    this.setState({imgSrc: await getImageSrc(this.state.event.featureImageStorageName)});

    checkAttend(id)
      .then(function(attending) {
          this.setState({buddyRequested: attending})
      }.bind(this))
  }

  handleClickOpenUrl(url) {
    window.open(url);
  }

  async handleClickRequestABuddy() {
    //let id = this.props.match.params.id;
    //ga(‘send’, ‘event’, ‘Button’, ‘Click’, ‘RequestBuddy’)
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'RequestBuddy',
      nonInteraction: true
    })
    if (signIn()) {
      if (await requestABuddy(this.state.event)) {
        window.alert("Thank you, we have received your request.");
        this.setState({buddyRequested: true})
      }
    }
    /*await requestABuddy(this.state.event);
    */
  }

  renderButton(caption, url) {
    var buttonStyle = {margin:"0px", width:"100%", backgroundColor:"var(--darkOrange)", fontSize:"16px"}
    if (!url) {
      buttonStyle = {margin:"0px", width:"100%", fontSize:"16px"}
    }
    return (
      <GridCell>
        <Button
          disabled={url?false:true}
          raised
          style={buttonStyle}
          onClick={e => this.handleClickOpenUrl(url)}
        >{caption}</Button>
      </GridCell>
    );
  }

  renderButtonRequestABuddy() {
    var buttonText = "Request A Buddy"
    var buttonStyle = {margin:"0px", width:"100%", backgroundColor:"var(--darkOrange)", fontSize:"16px"}
    if (this.state.buddyRequested) {
      buttonStyle = {margin:"0px", width:"100%", fontSize:"16px"}
      buttonText = "Buddy Already Requested";
    }
    return (
      <GridCell>
        <Button
          disabled={this.state.buddyRequested?true:false}
          raised
          style={buttonStyle}
          onClick={this.handleClickRequestABuddy}
        >{buttonText}</Button>
      </GridCell>
    );
  }

  renderButtons() {
    return (
      <Grid className="buttons">
        {this.renderButton("Tickets", this.state.event.ticketUrl)}
        {this.renderButton("Facebook", this.state.event.facebookUrl)}
        {this.renderButtonRequestABuddy("Request A Buddy")}
      </Grid>
    )
  }

  render() {
    const event = this.state.event
    return (
      <div>
      {(!this.state.event)?(
        <h1>Loading ...</h1>
      ):(
      <div>
        <Helmet>
          <title>{event.title}</title>
          <meta name='og:image' content={event.featureImageSrc} />
        </Helmet>
        <Grid className="event-header">
          <ImageGridCell src={this.state.imgSrc}/>
          <HeaderInfoGridCell {...event} />
        </Grid>
        {this.renderButtons()}
        <Description description={this.state.event.description} />
      </div>
      )
      }
      </div>
    );
  }
}

function Description(props) {
  return (
    <div className="description">
    <div className="description-title">DESCRIPTION</div>
    <div className="description-body">{props.description}</div>
    </div>
  )

}
function HeaderInfoGridCell(props) {
  return (
    <GridCell className="header-info" key={props.id} desktop="6" phone="4">
      <div className="title">{props.title}</div>
      <div className="on">ON</div>
      <div className="header-info-date-time-range">{FormatDate_ddd_MMM_d_yyyy(props.startDate)}</div>
      <div className="header-info-date-time-range">{FormatTimeRange_h_mm(props.startDate, props.stopDate)}</div>
      <HeaderInfoGridCellAddress {...props} />
      <HeaderInfoGridCellHostedBy {...props} />
    </GridCell>
  )
}
function HeaderInfoGridCellAddress(props) {
    return (
      <div className="header-info-address">
        <div className="at">AT</div>
        <div>{props.venue}</div>
        <div>{props.street}</div>
        <div>{props.locality}, {props.countrySubDivision}</div>
      </div>
    )
}
function HeaderInfoGridCellHostedBy(props) {
  return (
    (props.hostedBy)
    ?
    <div className="header-info-address">
      <div className="hosted-by">HOSTED BY</div>
      <div>{props.hostedBy}</div>
    </div>
    :
    <div></div>
  )
}
function ImageGridCell(props) {
  return (
    <GridCell className="event-gridcell" key={props.id} desktop="6" phone="4">
      <img
        className="event-image"
        src={props.src}
        alt={props.alt}
      />
    </GridCell>

  )
}

/*
localhost:3000/events/6KY9dLAngi960P79i5wi
*/



// WEBPACK FOOTER //
// ./src/containers/EventPage.js